module.exports = __webpack_public_path__ + "img/7z.d522b695.png";